import React from 'react';
import PaymentProcessing from '../components/PaymentProcessing/PaymentProcessing';

const PaymentProcessingScreen: React.FC = () => {
  return <PaymentProcessing />;
};

export default PaymentProcessingScreen;